import React from 'react';
import './OviCatalogosLanding.css';
import LandingHero from '../../components/LandingHero/LandingHero';
import LandingFeatures from '../../components/LandingFeatures/LandingFeatures';
import LandingTestimonials from '../../components/LandingTestimonials/LandingTestimonials';
import LandingCTA from '../../components/LandingCTA/LandingCTA';
import LandingFooter from '../../components/LandingFooter/LandingFooter';

function OviCatalogosLanding() {
    return (
        <div className="ovicatalogos-landing">
            <LandingHero />
            <LandingFeatures />
            <LandingTestimonials />
            <LandingCTA />
            <LandingFooter />
        </div>
    );
}

export default OviCatalogosLanding;
